<div class="overlay"></div>
<div class="page-content page-row">
  <div class="content">
    <div class="close" (click)='onClose.emit()'>
      <app-close class="close-icon"></app-close>
    </div>

    <p class="text text--size-l text--extra-bold text--center alert__title">{{title | translate}}</p>
    <p class="text" style="margin-top: 16px;">{{description | translate}}</p>

    <div class="actions" style="margin-top: 24px;">
      <button *ngIf='action' class="btn wide-btn" (click)="onAction.emit()">{{action | translate}}</button>
      <button *ngIf='close' class="btn wide-btn" (click)="onClose.emit()">{{close | translate}}</button>
    </div>
  </div>
</div>
